import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { StockLocation } from '@idealsupply/products-api-angular-client';
import { LoadingSkeletonDirective2 } from 'common-ui';
import { ErrorComponent } from 'error-ui';
import { ItemStockComponentStore } from 'products-data';
import { ItemComponentBase } from '../../../ItemComponentBase';
import { ItemStockButtonViewComponent } from './views/item-stock-button-view/item-stock-button-view.component';
import { ItemStockButtonState } from './views/item-stock-button-view/ItemStockButtonState';

@Component({
  selector: 'ideal-item-stock-button',
  imports: [ItemStockButtonViewComponent, LoadingSkeletonDirective2, ErrorComponent],
  standalone: true,
  templateUrl: './item-stock-button.component.html',
  styleUrl: './item-stock-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ItemStockComponentStore],
})
export class ItemStockButtonComponent extends ItemComponentBase {
  private readonly _stockStore = inject(ItemStockComponentStore);
  protected readonly stock = this._stockStore.itemStock;
  protected readonly stockLoading = this._stockStore.itemStock.loading;
  protected readonly stockError = this._stockStore.itemStock.error;
  protected readonly stockLocation = computed(() => this.stock()?.stockLocation);
  protected readonly stockTotal = computed(() => {
    const stock = this.stock();
    if (!stock) {
      return 0;
    }
    return stock.stock.reduce((total, s) => total + s.quantity, 0);
  });
  protected readonly stockReady = computed(() => !this.stockLoading() && !this.stockError() && !!this.stock()?.id);
  protected readonly atHomeBranch = computed(() => this.stock()?.stock.some((s) => s.isHomeBranch) ?? false);
  protected readonly state = computed(() => {
    switch (this.stockLocation()) {
      case StockLocation.None:
        return ItemStockButtonState.SOLD_OUT;
      case StockLocation.InWarehouse:
        return ItemStockButtonState.WAREHOUSE;
      case StockLocation.OnBackOrder:
        return ItemStockButtonState.BACK_ORDERED;
      case StockLocation.CanBackOrder:
        return ItemStockButtonState.ORDERABLE;
      case StockLocation.InStock:
        return this.atHomeBranch() ? ItemStockButtonState.IN_STORE : ItemStockButtonState.IN_STOCK;
    }
    return undefined;
  });

  constructor() {
    super();
    effect(() => {
      this._stockStore.selectProductById(this.id());
    });
  }
}
